import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';
import GuidedWorkflowV2Container from './GuidedWorkflowV2Container';
import ExtendedEntityDetails from './TopHeader/ExtendedEntityDetails';
import {getTaskDocumentByDocumentId} from '../../../../../../selectors/Ares/selectors';
import {useAresUrlParameters} from '../../../../../../util/Ares/customHooks';

export default function ExtendedV2Container() {
	const {documentId} = useAresUrlParameters();

	const docMetadata = useSelector((store) => {
		return getTaskDocumentByDocumentId(store, documentId);
	});

	const smartEvidenceSourceId = docMetadata?.smartEvidenceSourceId;
	const smartEvidenceSourceEntityId = docMetadata?.smartEvidenceSourceEntityID;
	const hasAnySystemAssociated = docMetadata?.hasAnySystemAssociated;

	const entityDetails = useMemo(() => {
		if (smartEvidenceSourceEntityId) {
			return (
				<ExtendedEntityDetails
					smartEvidenceSourceEntityId={smartEvidenceSourceEntityId}
					hasAnySystemAssociated={hasAnySystemAssociated}
					smartEvidenceSourceId={smartEvidenceSourceId}
				/>
			);
		}
	}, [smartEvidenceSourceEntityId, smartEvidenceSourceId]);

	return <GuidedWorkflowV2Container entityDetails={entityDetails} />;
}
